import type { FormInstance } from '@arco-design/web-react/es/Form';

import type { MaasNodeGroupsBlockOptions } from '@/delivery-type-plugin/capabilities/maas-node-groups/types';

import { KV_OFFLOAD_NODE_GROUP_FIELD_PATHS } from '../kvOffloadFieldPaths';
import { MiInferenceNodeGroupsBlock } from './MiInferenceNodeGroupsBlock';

export interface MiKvOffloadNodesBlockProps {
  form: FormInstance;
  options?: MaasNodeGroupsBlockOptions;
}

/** 缓存节点：副本数 → 环境变量 → 部署模式与节点，字段与推理拓扑隔离（不配置任务） */
export function MiKvOffloadNodesBlock({ form, options }: MiKvOffloadNodesBlockProps) {
  return (
    <MiInferenceNodeGroupsBlock form={form} options={options} fieldPaths={KV_OFFLOAD_NODE_GROUP_FIELD_PATHS} showClusterReplicas={false} />
  );
}
